import { render } from "./DocumentationsFirstForm.vue?vue&type=template&id=6862a57a"
import script from "./DocumentationsFirstForm.vue?vue&type=script&lang=js"
export * from "./DocumentationsFirstForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__